/**
 * Product recommendations row: asks Shopify for recommended products after the page has loaded and swaps the
 * section's own markup into place. Shopify answers with this same section rendered with its `recommendations`
 * data, so the cards come out of the same Liquid as the rest of the page.
 */
class TphProductRelatedComponent extends HTMLElement {
  /** @type {AbortController | null} */
  #abortController = null;

  connectedCallback() {
    if (this.hasAttribute('data-loaded')) return;
    this.#load();
  }

  disconnectedCallback() {
    this.#abortController?.abort();
  }

  async #load() {
    const url = this.dataset.url;
    if (!url) return;

    this.#abortController?.abort();
    this.#abortController = new AbortController();

    try {
      const response = await fetch(url, { signal: this.#abortController.signal });
      if (!response.ok) return;

      const markup = await response.text();
      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      const incoming = parsed.querySelector('tph-product-related-component');
      if (!incoming) return;

      this.setAttribute('data-loaded', '');
      this.innerHTML = incoming.innerHTML;
    } catch (error) {
      if (!(error instanceof DOMException && error.name === 'AbortError')) console.error(error);
    }
  }
}

if (!customElements.get('tph-product-related-component')) {
  customElements.define('tph-product-related-component', TphProductRelatedComponent);
}
